import React from "react";
import { Row } from "antd";
import { Accountpara,Accountparasub } from "../../InviteInterestedParties/Components/styles.js";

class UserSessionData extends React.Component {
  render() {
    let userData = JSON.parse(sessionStorage.getItem("primaryAccount"));
    return (
      <React.Fragment>
        <div data-test="sessionDataBlock">
          <Row>
            <Accountpara>{userData.accountName}</Accountpara><br />
            <Accountparasub>{userData.accountNumber}</Accountparasub>
          </Row>
        </div>
      </React.Fragment>
    )
  }
}
export default UserSessionData;